var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVouchersPrizes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11160",
    "data-name": "Group 11160",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4263",
    "data-name": "Rectangle 4263",
    width: 130,
    height: 130,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11094",
    "data-name": "Group 11094",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44779",
    "data-name": "Path 44779",
    d: "M130,65A65,65,0,1,1,65,0a65,65,0,0,1,65,65",
    fill: "#ffcd05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44780",
    "data-name": "Path 44780",
    d: "M202.849,202.466v13.9c0,1.174-2.224,3.387-3.387,3.387H154.736V204.334a17.193,17.193,0,0,0,10.978,4.439v-2.805a12.11,12.11,0,0,1-8.876-3.5Z",
    transform: "translate(-104.447 -136.665)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44781",
    "data-name": "Path 44781",
    d: "M202.849,157.945h-41.34l3.739-1.983c6.452-6.257-4.459-14.5-8.746-7.111-.677,1.167-.843,2.749-1.766,3.723V140.662H199.7c.957,0,3.153,2.207,3.153,3.153Z",
    transform: "translate(-104.447 -94.947)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44782",
    "data-name": "Path 44782",
    d: "M111.492,202.466c-2.067,2.427-5.745,3.621-8.876,3.5v2.805a17.683,17.683,0,0,0,7.551-1.91,35.8,35.8,0,0,1,3.193-2.062v14.948H100.632c-1.173,0-3.387-2.225-3.387-3.387v-13.9Z",
    transform: "translate(-65.64 -136.665)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44783",
    "data-name": "Path 44783",
    d: "M113.36,140.662v11.211l-2.334-4.255a5.739,5.739,0,1,0-7.79,8.424l3.818,1.9h-9.81v-14.13c0-.946,2.2-3.153,3.153-3.153Z",
    transform: "translate(-65.64 -94.947)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44784",
    "data-name": "Path 44784",
    d: "M230.23,263.551a16.2,16.2,0,0,1-.967,2.419,41.71,41.71,0,0,1-2.9,5.741,3.619,3.619,0,0,1-3.846,1.073L203.6,263.551Z",
    transform: "translate(-137.433 -177.897)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44785",
    "data-name": "Path 44785",
    d: "M116.648,115.524c1.024-1.945,2.233-6.338,4.122-7.439,1.632-.952,2.6-.4,4.136.232l14.631,7.207Z",
    transform: "translate(-78.737 -72.611)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44786",
    "data-name": "Path 44786",
    d: "M166.684,166.191a3.175,3.175,0,0,1-.273,4.368c-.392.35-7.077,3.314-7.359,3.032.93-2,2.053-7.328,4.135-8.123a3.1,3.1,0,0,1,3.5.723",
    transform: "translate(-107.36 -111.528)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44787",
    "data-name": "Path 44787",
    d: "M126.394,173.53c-.276.215-5.93-2.132-6.543-2.447-3.944-2.026-1.109-7.3,2.352-5.621,2.221,1.075,2.9,6.012,4.19,8.068",
    transform: "translate(-79.608 -111.468)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44788",
    "data-name": "Path 44788",
    d: "M86.411,196.088c-.434.1-.453-.143-.663-.388-1.351-1.577-.713-4.1.663-5.451Z",
    transform: "translate(-57.375 -128.418)",
    fill: "#d9261c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44789",
    "data-name": "Path 44789",
    d: "M310.682,191.686a3.26,3.26,0,0,1,1.047,4.2l-1.047,1.873Z",
    transform: "translate(-209.71 -129.388)",
    fill: "#d9261c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVouchersPrizes);
export default __webpack_public_path__ + "static/media/vouchers-prizes.c937bb6fdf7d9754e41490a9c0acd6e4.svg";
export { ForwardRef as ReactComponent };